/**
 * RouteBack
 * 
 * @Author: Focci
 * @Date: 2023-09-28 15:09:14
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-28 15:09:14
 */

import PropTypes from 'prop-types'
import clsx from 'clsx'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useCallback } from 'react'
import { useTranslations } from 'next-intl'
import useProgressRouter from '@hook/useProgressRouter'
import { isFunction } from 'lodash-es'

export default function RouteBack({
  className = 'border-r pr-2 mr-2',
  iconFontSize = '.9rem',
  onClick
}) {
  const tc = useTranslations('common')
  const { routerBack } = useProgressRouter()
  const handleBack = useCallback(
    () => (isFunction(onClick) ? onClick() : routerBack()),
    [routerBack, onClick]
  )

  return (
    <div
      className={clsx([
        'flex items-center gap-x-0.5 cursor-pointer',
        className
      ])}
      onKeyPress={handleBack}
      onClick={handleBack}
      role="button"
      tabIndex="0"
    >
      <ArrowBackIcon sx={{ fontSize: iconFontSize }} />
      <span className="whitespace-nowrap">
        {tc('back')}
      </span>
    </div>
  )
}

RouteBack.propTypes = {
  className: PropTypes.string,
  iconFontSize: PropTypes.string,
}
